/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get } from 'lodash';

// Components
import InputAutocomplete from 'shared/ui/components/form-components/InputAutocomplete.vue';
import RadioButtons from 'shared/ui/components/form-components/RadioButtons.vue';

const __vue_script__ = {
    name: 'MemberRoleEditor',

    components: { InputAutocomplete, RadioButtons },

    props: {
        event: {
            type: Object,
            required: true
        },

        content: {
            type: Object,
            default: null
        },

        showTitle: {
            type: Boolean,
            default: true
        },

        excludeEmails: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            access: get(this.content, 'role.role', 'viewer'),
            editing: this.content !== null,
            email: get(this.content, 'email'),
            members: [],
            orgId: this.event.ownerId || this.event.bs_owner_id,
            showPermissionError: false,
            showPermissionErrorNotInOrg: false,
            submitting: false,
            title: this.content ? this.content.realname : this.$t('team_members.actions.add'),
            mainRoles: [{
                value: 'manager',
                label: this.$t('team_members.roles.manager'),
                hint: this.$t('team_members.form.manager_hint')
            }, {
                value: 'editor',
                label: this.$t('team_members.roles.editor'),
                hint: this.$t('team_members.form.editor_hint')
            }, {
                value: 'viewer',
                label: this.$t('team_members.roles.viewer'),
                hint: this.$t('team_members.form.viewer_hint')
            }],
            predefinedRoles: [{
                value: 'meeting_planner',
                label: this.$t('team_members.roles.meeting_planner'),
                hint: this.$t('team_members.form.meeting_planner_hint')
            }, {
                value: 'badge_printing_staff',
                label: this.$t('team_members.roles.badge_printing_staff'),
                hint: this.$t('team_members.form.badge_printing_staff_hint')
            }],
        };
    },

    async created() {
        if (!this.editing) {
            const orgName = this.$services.org.getNameFromId(this.orgId);
            this.members = await this.$services.org.getMemberEmails(orgName, this.excludeEmails);
        }
    },

    methods: {
        onRoleChange() {
            if (this.editing) {
                this.save();
            }
        },

        async save() {
            const eventId = this.event._id || this.event.id;
            try {
                this.submitting = true;
                const form = this.$refs.form;
                const valid = await form.validate();

                if (!valid) {
                    console.warn('[MemberRoleEditor] Form is not valid');
                    return;
                }

                const response = await this.$services.event.setTeamMemberRole(eventId, this.email, this.access);
                this.$emit('completed', response);

            } catch (error) {
                const { response } = error;
                if (response?.status === 404 || response?.status === 403) {
                    const canCreateNewUser = this.$services.user.canCreateBackstageUsers(this.orgId);
                    if (canCreateNewUser) {
                        if (response?.status === 403) {
                            console.info('[MemberRoleEditor] Adding user to the org as guest');
                            this.showPermissionErrorNotInOrg = true;
                            this.$emit('error');
                        } else {
                            console.info('[MemberRoleEditor] Redirecting to the user creation form');
                            const createUserPath = this.$services.event.NEW_USER_PATH;
                            const redirectUrl = this.$services.event.buildUrl(createUserPath, {
                                eventId,
                                role: this.access,
                                email: encodeURIComponent(this.email),
                                org: this.orgId
                            });

                            this.$services.router.redirect(redirectUrl);
                        }
                    } else {
                        this.showPermissionError = true;
                        this.$emit('error');
                    }

                } else {
                    console.error('[MemberRoleEditor] Could not save the role settings', error.message);
                }
            } finally {
                this.submitting = false;
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"member-role-editor"},[(_vm.showTitle)?_c('h2',[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.showPermissionError)?_c('div',{staticClass:"alert alert-danger"},[_c('p',[_vm._v(_vm._s(_vm.$t('team_members.messages.permission_error')))])]):(_vm.showPermissionErrorNotInOrg)?_c('div',{staticClass:"alert alert-danger"},[_c('p',[_vm._v(_vm._s(_vm.$t('team_members.messages.permission_error_user_not_in_org')))])]):_c('validation-observer',{ref:"form",staticClass:"member-editor",attrs:{"tag":"form"}},[_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"email"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('input-autocomplete',{attrs:{"name":"email","label":_vm.$t('general.forms.labels.email'),"tip":_vm.editing ? null : _vm.$t('team_members.form.email_address_tip'),"errors":errors,"disabled":_vm.editing,"suggestions":_vm.members},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})]}}])}),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"access"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('radio-buttons',{attrs:{"name":"role","label":_vm.$t('team_members.form.access_role'),"disabled":_vm.submitting,"errors":errors,"options":_vm.mainRoles},on:{"input":_vm.onRoleChange},model:{value:(_vm.access),callback:function ($$v) {_vm.access=$$v},expression:"access"}}),_c('radio-buttons',{attrs:{"name":"role","label":_vm.$t('team_members.form.predefined_role'),"disabled":_vm.submitting,"errors":errors,"options":_vm.predefinedRoles},on:{"input":_vm.onRoleChange},model:{value:(_vm.access),callback:function ($$v) {_vm.access=$$v},expression:"access"}})]}}])})],1)],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "MemberRoleEditor.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__